import { action } from 'satcheljs';
import { HostedApp } from '../store/schema/AppHostStore';

export const updateHostedApp = action('updateHostedApp', (app: HostedApp) => ({
    app,
}));
